// ======================================================================
// File Name       : ContentDrillSkinRegisterUpdate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import { MODE, VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FileUpload from '../FileUpload';

class ContentDrillSkinRegisterUpdate extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const { skinSetInfo, mode, handleChange, handleFileChange, handleSubmit } = this.props;
    this.refsToValidate = [];
    const requiredClass = mode === MODE.NEW_MODE && <span className="required">&nbsp;(※)</span>;
    return (
      <Col as={Form.Label} sm={12}>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="form-horizontal"
        >
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              スキン識別ID
            </Col>
            <Col sm={7} className="padding-left-clear">
              {mode === MODE.NEW_MODE ? (
                <FormControlValidate
                  type="text"
                  label="スキン識別ID"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  name="skinSetSecernId"
                  maxLength="64"
                  value={skinSetInfo.skinSetSecernId}
                  validateType={VALIDATE_TYPE.ID}
                  onChange={handleChange}
                />
              ) : (
                <Col sm={7} as={Form.Label} className="padding-left-clear">
                  {skinSetInfo.skinSetSecernId || ""}
                </Col>
              )}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              スキン名 {requiredClass}
            </Col>
            <Col sm={7} className="padding-left-clear">
              <FormControlValidate
                type="text"
                label="スキン名"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                name="skinSetName"
                maxLength="256"
                required
                value={skinSetInfo.skinSetName}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={4}>
              ファイル名 {requiredClass}
            </Col>
            <Col sm={7} className="padding-left-clear">
              <Col sm={9} className="padding-left-clear">
                <FormControlValidate
                  label="ファイル名"
                  type="text"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  name="skinSetZipFileName"
                  value={skinSetInfo.skinSetZipFileName}
                  required
                  disabled
                />
              </Col>
              <Col sm={3} className="padding-left-right-clear float-end">
                <FileUpload
                  labelName="ファイル選択"
                  onChange={handleFileChange}
                  fileName={skinSetInfo.skinSetZipFileName}
                  accept={
                    "application/zip,application/x-zip,application/x-zip-compressed"
                  }
                />
              </Col>
            </Col>
          </Form.Group>
          <input type="submit" hidden="true" />
        </Form>
      </Col>
    );
  }
}

export default ContentDrillSkinRegisterUpdate;
